import { ExternalLink } from "lucide-react";
import { CopyCodeButton } from "@/components/CopyCodeButton";

export const PropfirmSection = () => (
    <div className="fade-in" data-testid="propfirm-section">
      <div className="text-center mb-12">
        <h2 className="text-4xl sm:text-6xl font-bold mb-6" data-testid="propfirm-title">
          PropFirm Partenaire
        </h2>
        <p className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto">
          Testez vos compétences et accédez à du capital de trading avec notre propfirm partenaire de confiance
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="relative p-12 rounded-2xl bg-white/5 border-2 border-white/10 backdrop-blur-sm">
          <div className="text-center mb-8 pt-6 sm:pt-0">
            <img src="/logos/blueberry-funded.svg" alt="Logo Blueberry Funded" className="absolute top-5 left-5 h-7 w-auto" data-testid="propfirm-logo" />
            <h3 className="text-3xl font-bold mb-4">Blueberry Funded</h3>
            <p className="text-white/70 leading-relaxed">
              Passez les challenges de Blueberry Funded et tradez avec leur capital. Des règles claires, des payouts rapides et un support réactif.
            </p>
          </div>

          {/* Code Promo Highlight */}
          <div className="mb-8 p-6 rounded-xl bg-gradient-to-r from-amber-500/20 to-orange-500/20 border-2 border-amber-400/40">
            <div className="flex items-center justify-center gap-3 mb-3">
              <span className="text-3xl">🎁</span>
              <h4 className="text-2xl font-bold text-amber-400">Réduction Exclusive 700S ICT</h4>
            </div>
            <p className="text-center text-xl font-bold mb-3">
              <span className="text-amber-300">-30 % sur tous les challenges !</span>
            </p>
            <div className="bg-black/30 p-4 rounded-lg border border-amber-400/30">
              <p className="text-center text-base font-semibold text-white mb-3">
                ⚠️ IMPORTANT : utilisez le code promo lors de l'achat de votre challenge
              </p>
              <div className="flex items-center justify-center gap-3">
                <span className="text-white/80">Code :</span>
                <CopyCodeButton code="700S" />
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 mb-8">
            <div className="text-center p-6 rounded-xl bg-white/5">
              <h4 className="text-2xl font-bold mb-2">Jusqu'à</h4>
              <p className="text-3xl font-bold text-blue-400">$200K</p>
              <p className="text-sm text-white/60 mt-2">Capital de trading</p>
            </div>
            <div className="text-center p-6 rounded-xl bg-white/5">
              <h4 className="text-2xl font-bold mb-2">Jusqu'à</h4>
              <p className="text-3xl font-bold text-green-400">90 %</p>
              <p className="text-sm text-white/60 mt-2">Part des profits</p>
            </div>
            <div className="text-center p-6 rounded-xl bg-white/5">
              <h4 className="text-2xl font-bold mb-2">Payout</h4>
              <p className="text-3xl font-bold text-purple-400">Rapide</p>
              <p className="text-sm text-white/60 mt-2">En 24 à 48 h</p>
            </div>
          </div>

          <div className="text-center">
            <a
              href="https://blueberryfunded.com/?utm_source=affiliate&ref=868"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-black font-bold text-lg rounded-lg hover:bg-white/90 hover:scale-105 transition-all shadow-xl"
              data-testid="propfirm-cta-button"
            >
              Découvrir Blueberry Funded
              <ExternalLink size={22} />
            </a>
            <p className="mt-4 text-sm text-white/50">
              Lien partenaire 700S ICT
            </p>
          </div>
        </div>

        {/* Benefits List */}
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="p-6 rounded-xl bg-white/5 border border-white/10">
            <h4 className="font-bold text-lg mb-3">✓ Challenge Flexible</h4>
            <p className="text-white/70 text-sm">Choisissez votre taille de compte et passez les étapes à votre rythme</p>
          </div>
          <div className="p-6 rounded-xl bg-white/5 border border-white/10">
            <h4 className="font-bold text-lg mb-3">✓ Sans Limite de Temps</h4>
            <p className="text-white/70 text-sm">Pas de deadline pour valider votre challenge</p>
          </div>
          <div className="p-6 rounded-xl bg-white/5 border border-white/10">
            <h4 className="font-bold text-lg mb-3">✓ Scaling Plan</h4>
            <p className="text-white/70 text-sm">Augmentez votre capital jusqu'à 200 000 $</p>
          </div>
          <div className="p-6 rounded-xl bg-white/5 border border-white/10">
            <h4 className="font-bold text-lg mb-3">✓ Support Dédié</h4>
            <p className="text-white/70 text-sm">Équipe disponible pour répondre à toutes vos questions</p>
          </div>
        </div>
      </div>
    </div>
);
